import React from 'react';
import { DATA_HOOKS } from '../constants';
const Slide = ({ dataHook, className, children, image, width, gutter, imagePosition, imageFit, }) => (React.createElement("div", { "data-hook": dataHook, className: className, role: "listitem", style: {
        flex: '0 0 auto',
        width,
        marginInlineStart: gutter,
        objectPosition: imagePosition,
        objectFit: imageFit,
    } }, image ? (React.createElement("img", { "data-hook": DATA_HOOKS.carouselImage, src: image.src })) : (children)));
export default Slide;
//# sourceMappingURL=Slide.js.map